import React from 'react';

export const WidgetsPage = React.lazy(() => import('./WidgetsPage'));
